import React, {useEffect} from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default function Herosec() {
    useEffect(() => {
        AOS.init({duration:1000})
    }, [])
    
    return (
        <section className="hero-section page-section scroll-to-page" id="home">
            <div className="custom-container">
                <div className="hero-content content-width">
                    <div className="section-header">
                        <h4 className="subtitle scroll-animation" data-aos='fade-up'>
                            <i className="las la-home"></i> Introduction
                        </h4>
                        <h1 className="scroll-animation" data-aos='fade-up'>
                            Distinguished Architect at <span>Walmart Global Tech</span>
                        </h1>
                    </div>
                    <p className="scroll-animation" data-aos='fade-up'>
                        Enterprise Software Architect specializing in scalable solutions and cloud computing
                    </p>
                    <div className="facts d-flex">
                        <div className="left scroll-animation" data-aos='fade-right'>
                            <h1>26+</h1>
                            <p>Years of<br/>Experience</p>
                        </div>
                        <div className="right scroll-animation" data-aos='fade-left'>
                            <h1>1</h1>
                            <p>Patent in Automation of Business components <br/>testing for Fusion framework</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
